import { CircularProgress } from 'design-system';
import { IAudiencePreviewJson, INamedObjectTypes } from '@scale/shared/types/lookup';
import { useObjectPreview } from 'corp/hooks/smartId/useObjectPreview';
import IsomorphicLink from 'corp/components/UI/IsomorphicLink';

const AudiencePreview: React.FC<{ id: string }> = ({ id }) => {
  const {
    value: audience,
    loading,
    error,
  } = useObjectPreview<IAudiencePreviewJson>(id, INamedObjectTypes.Audience);

  if (error) {
    return <span>Sorry, there was an error</span>;
  }

  if (loading) {
    // The margin is to avoid the loader overlapping with the close icon
    return (
      <div style={{ marginRight: '1rem' }}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <div className="audience-preview">
      <style jsx>{`
        .audience-preview__banner {
          font-weight: bold;
          padding: 10px;
          display: flex;
          align-items: center;
        }

        .audience-preview__thing-list > div {
          display: flex;
        }

        .audience-preview__thing-list strong {
          color: #666;
          margin-right: 10px;
          min-width: 120px;
          text-align: right;
        }
      `}</style>
      {audience && (
        <>
          <div className="audience-preview__banner">
            <h3 style={{ margin: '0 5px' }}>{audience.name}</h3>
          </div>
          <div className="audience-preview__body">
            <div className="audience-preview__thing-list">
              <div>
                <strong>Lookup</strong>
                <IsomorphicLink target="_blank" rel="noopener noreferrer" href={`/audience/${id}`}>
                  {id}
                </IsomorphicLink>
              </div>
              <div>
                <strong>Total user count</strong>
                <span>{audience.users}</span>
              </div>
              <div>
                <strong>Buckets</strong>
                {audience.buckets.map((bucket, bucketIndex) => (
                  <span key={bucketIndex} style={{ margin: 0, whiteSpace: 'nowrap' }}>
                    {bucket.name ?? `Bucket ${bucketIndex + 1}`} &nbsp; ({bucket.percentage}%){' '}
                    {bucket.users.toLocaleString()}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AudiencePreview;
